// @flow strict

import * as React from 'react'
import cx from 'classnames'
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from '@reach/accordion'
import { type Feature } from '../FeatureDiscoveryGrid'
import styles from './FeatureDiscoveryAccordion.module.scss'

type FeatureAccordionProps = {
  features: Feature[],
}

const FeatureDiscoveryAccordion = ({ features }: FeatureAccordionProps) => (
  <Accordion collapsible multiple className={styles.accordion}>
    {features.map((feature, i) => {
      return (
        <React.Fragment key={feature.title}>
          <AccordionItem>
            <h3>
              <AccordionButton
                className={cx(styles.accordionTitle, styles[`bg${i}`])}
              >
                <img src={feature.iconSrc} alt="" />
                <div className={styles.accordionTitleText}>{feature.title}</div>
                <span className={styles.downCaret}>▾</span>
              </AccordionButton>
            </h3>
            <AccordionPanel className={styles.accordionText}>
              <div className={styles.accordionDescriptionWrapper}>
                <p>{feature.description}</p>
              </div>
            </AccordionPanel>
          </AccordionItem>
        </React.Fragment>
      )
    })}
  </Accordion>
)

export default FeatureDiscoveryAccordion
